import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

export const EmptyBlock = () => (
  <Box
    height="full"
    flexDirection="column"
    gap="s8"
    width="s400"
    paddingX="s24"
    alignItems="center"
    textAlign="center"
  >
    <Icon.Large icon="file" color="grey600" />
    <Text.Header2>
      {i18n.t('expenses.settings.signed_invoices.list.table.empty_state.title')}
    </Text.Header2>
    <Text.Normal color="grey800">
      {i18n.t('expenses.settings.signed_invoices.list.table.empty_state.description')}
    </Text.Normal>
  </Box>
)
